// eslint-disable-next-line no-unused-vars
const analyticsTypes = require('../jsdoc-types');
const { analyticsEventBus } = require('../events');
const {
  searchDataStorage,
  searchDataOfCartItemsStorage,
} = require('../stores/searchData');
const { getPidWithoutSize } = require('../../common/helpers/productIdHelpers');
const analyticsConst = require('../analyticsConst');

const { LIST_NAMES } = analyticsConst;

/**
 * Handle search data from search event
 * Get search data from localStorage or asign an empty array
 * If product already exists in stored searchData, update info
 * If product does not exist in stored searchData, create object
 * Set searchData in localStorage
 * @param {Object} data search data from event
 * @param {Object[]} data.products array of products results from search
 * @param {Object} data.search search data from event
 * @param {number} data.search.count search count
 * @param {boolean} data.search.isCached search is cached
 * @param {string} data.search.match search match
 * @param {number} data.search.page search page
 * @param {string} data.search.query search query
 */
function trackSearchData(data) {
  const products = data?.products ?? [];
  if (products.length === 0) return;

  products.forEach((product) => {
    const productID = product.product.id;
    const { count, match, query } = data.search;
    searchDataStorage.setItem(productID, {
      count,
      match,
      query,
    });
  });
}

/**
 * Track the search data of a product when it has been added to cart
 *
 * @param {Object} payload The payload of the event
 * @param {Cart} payload.cart - The cart
 * @param {string} payload.context Section from which the product was added to cart
 * @param {string} payload.doubleLookPID The ID of the double look product
 * used to add to cart (ex: '241BZ0439.10000_DL137')
 * @param {string} [payload.list] The list type of the event
 * @param {number} [payload.position] The position of the product (zero-based)
 * @param {FullProduct} payload.product The full product data
 * @param {ProductLineItem} payload.productLineItem The product line item
 * corresponding to the added product
 */
function trackCartSearchData({ product, context, list }) {
  const evtPayloads = analyticsEventBus.EVENTS.PAYLOADS.productAddedToCart;
  const addedFromQuickshopOfSearchList = context === evtPayloads.context.search;
  const addedFromPdpAccededFromSearchList =
    context === evtPayloads.context.product && list === LIST_NAMES.search;
  const mustCopyToCartStorage =
    addedFromQuickshopOfSearchList || addedFromPdpAccededFromSearchList;
  if (mustCopyToCartStorage) {
    const variationGroupId = getPidWithoutSize(product.id);
    const searchData = searchDataStorage.getItem(variationGroupId);
    searchDataOfCartItemsStorage.setItem(product.id, searchData); // variant
    searchDataOfCartItemsStorage.setItem(variationGroupId, searchData); // variation group
  }
}

/**
 * Begin the tracking for gaInfo related data
 */
function beginTracking() {
  analyticsEventBus.subscribe(
    analyticsEventBus.EVENTS.searchReturnedResults,
    trackSearchData
  );
  analyticsEventBus.subscribe(
    analyticsEventBus.EVENTS.productAddedToCart,
    trackCartSearchData,
    {
      synchronous: true,
    }
  );
}

module.exports = {
  beginTracking,
};
